import React, { Component } from 'react';
import StationService from '../services/station_service';
import DropDownListS from './dropdown';

class StepOne extends Component {
  state = {
    stationList: [],
    error: '',
  };

  componentDidMount() {
    this.fetchStations();
  }

  fetchStations = async () => {
    try {
      const { sourcePath } = this.props;
      const res = await StationService.getStations(`${sourcePath}/Input_Documents`);
      this.setState({ stationList: res.data.stations });
    } catch (err) {
      this.setState({ error: 'Failed to fetch stations.' });
    }
  };

  handleRunDocuments = async () => {
    const { station, sourcePath, handleNext, setLoading } = this.props;

    if (!station) {
      this.setState({ error: 'Please select a station.' });
      return;
    }

    setLoading(true);

    try {
      await StationService.copyToInputs({
        source_path: `${sourcePath}/Input_Documents/${station}/VERSION_IN_BACKEND`,
        station,
        output_path: `${sourcePath}/Output_Documents/${station}/VERSION_IN_BACKEND/inputs`,
      });

      handleNext();
    } catch (err) {
      this.setState({ error: `Upload Station_Info_${station}.xlsx in Input documents` });
      setLoading(false);
    }
  };

  render() {
    const { station, setStation, loading } = this.props;
    const { stationList, error } = this.state;

    const isButtonDisabled = loading || !station;

    return (
      <div className="container py-4">
        <label htmlFor="station-select" className="form-label fw-semibold fs-5">
          Select Station
        </label>

        <div className="d-flex align-items-center gap-2">
          <DropDownListS
            selectedValue={station}
            data={stationList.map((s) => ({ value: s, label: s }))}
            onUpdateSelectedValue={setStation}
            placeholder="Select Station"
            width="100" // optional Bootstrap width class suffix
            placeholderColor="#6c757d"
            disabled={loading}
          />

          <button
            onClick={this.handleRunDocuments}
            className="btn btn-dark py-3 px-4"
            disabled={isButtonDisabled}
            style={{ background: '#193e6c', whiteSpace: 'nowrap' }}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Processing...
              </>
            ) : (
              <>
                <span className="d-inline d-md-none">Run →</span>
                <span className="d-none d-md-inline">Run Documents →</span>
              </>
            )}
          </button>
        </div>

        {error && (
          <div className="alert alert-warning text-center fw-bold mt-3">
            {error}
          </div>
        )}
      </div>
    );
  }
}

export default StepOne;
